<template>
<div class="chapter">
<div class="inner_page">
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c14.vue?6dc0a06e